import { Typography } from '@mui/material'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Body() {
  const texts = useTexts()
  const {
    data: { simulationIds },
  } = useController()

  return <Typography>{texts.body(simulationIds.length)}</Typography>
}
